import React, { useContext, useState } from "react";
import styled from "styled-components";
import { auth } from "../firebase/firebaseConfig"; // your Firebase config
import {
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from "firebase/auth";
import { UserContext } from "../context/UserContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  background: #121212;
  min-height: 100vh;
  padding: 40px 20px;
  color: #f1f1f1;
  font-family: "Segoe UI", Arial, sans-serif;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const Card = styled.div`
  background: #1e1e1e;
  padding: 30px 40px;
  width: 100%;
  max-width: 500px;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.5);
`;

const Title = styled.h2`
  margin-bottom: 25px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
`;

const FieldGroup = styled.div`
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #bbb;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 14px;
  border-radius: 8px;
  border: none;
  background: #2c2c2c;
  color: #fff;
  font-size: 15px;
`;

const Button = styled.button`
  background: #6200ea;
  color: white;
  padding: 12px 18px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  margin-top: 15px;
  font-weight: 600;
  transition: 0.3s ease;
  &:hover {
    background: #4500b5;
  }
`;

export default function ChangePasswordPage() {
  const { user } = useContext(UserContext); // Firebase user
  const navigate = useNavigate();

  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.newPassword !== form.confirmPassword) {
      toast.error("New passwords do not match ❌");
      return;
    }

    setLoading(true);

    try {
      // Re-authenticate user
      const credential = EmailAuthProvider.credential(
        user.email,
        form.currentPassword
      );
      await reauthenticateWithCredential(auth.currentUser, credential);

      // Update password
      await updatePassword(auth.currentUser, form.newPassword);

      toast.success("Password updated successfully ✅");
      navigate("/profile/" + user.uid);
    } catch (error) {
      console.error("Error updating password:", error);
      toast.error(error.message || "Failed to update password ❌");
    }

    setLoading(false);
  };

  return (
    <Container>
      <Card>
        <Title>Change Password</Title>
        <form onSubmit={handleSubmit}>
          <FieldGroup>
            <Label>Current Password</Label>
            <Input
              type="password"
              name="currentPassword"
              value={form.currentPassword}
              onChange={handleChange}
              required
            />
          </FieldGroup>

          <FieldGroup>
            <Label>New Password</Label>
            <Input
              type="password"
              name="newPassword"
              value={form.newPassword}
              onChange={handleChange}
              required
            />
          </FieldGroup>

          <FieldGroup>
            <Label>Confirm New Password</Label>
            <Input
              type="password"
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              required
            />
          </FieldGroup>

          <Button type="submit" disabled={loading}>
            {loading ? "Updating..." : "Update Password"}
          </Button>
        </form>
      </Card>
    </Container>
  );
}
